(function () {
  if (window.__hmFfCountdownInit) return;
  window.__hmFfCountdownInit = true;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function setText(root, sel, value) {
    var el = root.querySelector(sel);
    if (el) el.textContent = value;
  }

  function showZeros(root) {
    setText(root, '[data-ff-days]', '00');
    setText(root, '[data-ff-hours]', '00');
    setText(root, '[data-ff-mins]', '00');
    setText(root, '[data-ff-secs]', '00');
  }

  function showMessage(root, message) {
    var timer = root.querySelector('[data-ff-countdown-timer]');
    var msg = root.querySelector('[data-ff-countdown-message]');
    if (timer) timer.hidden = true;
    if (msg) {
      msg.hidden = false;
      if (message) msg.textContent = message;
    }
  }

  function applyExpired(root, behavior, message) {
    root.setAttribute('data-expired', 'true');

    var designMode = root.hasAttribute('data-ff-countdown-design-mode');

    if (behavior === 'hide') {
      if (designMode) {
        showZeros(root);
        return;
      }
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      return;
    }

    if (behavior === 'message') {
      showMessage(root, message);
      return;
    }

    showZeros(root);
  }

  function tick() {
    document.querySelectorAll('[data-ff-countdown]').forEach(function (root) {
      if (root.getAttribute('data-expired') === 'true') return;

      var endSeconds = parseInt(root.getAttribute('data-ff-countdown') || '', 10);
      var behavior = root.getAttribute('data-expired-behavior') || 'show_zeros';
      var message = root.getAttribute('data-expired-message') || '';

      if (!isFinite(endSeconds) || endSeconds < 1000000000) {
        applyExpired(root, 'hide', message);
        return;
      }

      var diff = endSeconds * 1000 - Date.now();
      if (diff <= 0) {
        applyExpired(root, behavior, message);
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      setText(root, '[data-ff-days]', pad(d));
      setText(root, '[data-ff-hours]', pad(h));
      setText(root, '[data-ff-mins]', pad(m));
      setText(root, '[data-ff-secs]', pad(s));
    });
  }

  tick();
  setInterval(tick, 1000);
})();
